import React, { useState } from "react"

import { Crisp } from "crisp-sdk-web"
import { Switch, Route } from "react-router-dom"

import User from "@/services/User"
import AuthService from "@/services/Auth"

import PrivateRoutes from "@/routes/private"
import PublicRoutes from "@/routes/public"

import { Loading } from "@/components"
import { useGlobalStateStore } from "@/store/GlobalState"

import useDidMount from "@/hooks/useDidMount"
import useAuthReturnUrl from "@/hooks/useAuthReturnUrl"
import enviroment from "@/config/enviroment"

const PrivateComponent = () => {
	const [loading, setLoading] = useState(true)
	const useGlobalState = useGlobalStateStore()
	const { redirectToSignInWithReturnUrl } = useAuthReturnUrl()

	const handleInitializeUserSession = async () => {
		const isLoggedIn = await AuthService.isLoggedIn()

		if (!isLoggedIn) {
			redirectToSignInWithReturnUrl()
		}

		const user = await User.getInfo()

		if (user) {
			useGlobalState.setUserData({
				id: user?.userData?.id,
				name: user?.userData?.name,
				email: user?.userData?.email
			})
		}

		Crisp.configure(enviroment.crispWebSiteId as string, {
			autoload: isLoggedIn
		})

		setLoading(false)
	}

	useDidMount(() => {
		handleInitializeUserSession()
	})

	return (
		<Loading loading={loading}>
			<PrivateRoutes />
		</Loading>
	)
}

const Routes = () => (
	<Switch>
		{PublicRoutes}
		<Route path="/" component={PrivateComponent} />
		<Route path="*" component={() => <h1>Page Not Found</h1>} />
	</Switch>
)

export default Routes
